import React from "react";
import { motion } from "framer-motion";

export const Page = ({ children }) => (
  <motion.main
    initial={{ opacity: 0, y: 8, filter: "blur(2px)" }}
    animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    exit={{ opacity: 0, y: -6, filter: "blur(2px)" }}
    transition={{ duration: 0.42, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.main>
);
